module.exports = __webpack_public_path__ + "images/history-cat-0-f91c7800693ac0fb401b5f002aee8aca.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-cat-0.png
 ** module id = 387
 ** module chunks = 0
 **/